const canvasSketch = require("canvas-sketch");
const Tinycolor = require("@ctrl/tinycolor").TinyColor;
const random = require("canvas-sketch-util/random");
const math = require("canvas-sketch-util/math");

const settings = {
  animate: true,
  // dimensions: [1920, 1080],
};

const hueRotationSpeed = 0.2;

let hue = 50;

let color = new Tinycolor({
  h: hue,
  s: 1.0,
  l: 0.05,
});

const agents = [];
const nbAgents = 50;
const maxVelocity = 0.2;


const sketch = async ({ context, width, height }) => {
  const noiseCanvas = generateNoise(width, height);

  

	for (let i = 0; i < nbAgents; i++) {
		const x = random.range(0, width);
		const y = random.range(0, height);

		agents.push(new Agent(x, y));
	}

  return ({ context, width, height, frame }) => {
    let gradient = context.createLinearGradient(0, 0, width, height);
    gradient.addColorStop(0, "#1A1A1A");
    gradient.addColorStop(1, color.toHexString());

    context.fillStyle = gradient;
    context.fillRect(0, 0, width, height);

    hue += hueRotationSpeed;
    hue %= 360;

    color = new Tinycolor({
      h: hue,
      s: 1.0,
      l: 0.05,
    });

    // hue %= 360;

    // drawAgents(context, width, height);
    context.drawImage(generateBits(width, height, frame), 0, 0);
    context.drawImage(noiseCanvas, 0, 0);
  };
};



function generateNoise(width, height) {
  const noiseCanvas = document.createElement("canvas");
  noiseCanvas.width = width;
  noiseCanvas.height = height;
  const ctx = noiseCanvas.getContext("2d");
  const iData = ctx.createImageData(width, height),
    buffer32 = new Uint32Array(iData.data.buffer),
    len = buffer32.length;
  let i = 0;

  for (; i < len; i++) if (Math.random() < 0.5) buffer32[i] = 0x44000000;

  ctx.putImageData(iData, 0, 0);
  return noiseCanvas;
}

function generateBits(width, height, frame) {
  const SPEED_DIVISOR = 100;
  const MIN_ALPHA = 0.025;
  const MAX_ALPHA = 0.07;

  const bitsCanvas = document.createElement("canvas");
  bitsCanvas.width = width;
  bitsCanvas.height = height;

  const ctx = bitsCanvas.getContext("2d");
  ctx.font = "20px monospace";
  ctx.textBaseline = "top";

  const metrics = ctx.measureText("0");
  // console.log(metrics);
  // const mx = metrics.actualBoundingBoxLeft * -1;
  // const my = metrics.actualBoundingBoxAscent * -1;
  // const mw = metrics.actualBoundingBoxLeft + metrics.actualBoundingBoxRight + 2;
  // const mh =
  //   metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent + 2;
  const mw = metrics.width;
  const mh = mw + 4;

  const cols = Math.floor(width / mw),
    rows = Math.floor(height / mh);

  const marginLeft = width - cols * mw;
  const marginTop = (height - rows * mh) / 2;

  for (let x = 0; x < cols; x++) {
    for (let y = 0; y < rows; y++) {
      const n = random.noise3D(x, y, frame / SPEED_DIVISOR, 1);
      const character = n <= 0.1 ? "0" : "1";
      const alpha = math.mapRange(n, 0, 1, MIN_ALPHA, MAX_ALPHA);
      ctx.fillStyle = `rgba(255,255,255,${alpha})`;
      ctx.fillText(character, marginLeft + x * mw, marginTop + y * mh);
    }
  }

  return bitsCanvas;
}


class Vector {
	constructor(x, y) {
		this.x = x;
		this.y = y;
	}

	getDistance(v) {
		const dx = this.x - v.x;
		const dy = this.y - v.y;
		return Math.sqrt(dx * dx + dy * dy);
	}
}

class Agent {
	constructor(x, y) {
		this.pos = new Vector(x, y);
		this.vel = new Vector(random.range(-maxVelocity, maxVelocity), random.range(-maxVelocity, maxVelocity));
		this.radius = random.range(4, 12);
	}

	bounce(width, height) {
		if (this.pos.x <= 0 || this.pos.x >= width)  this.vel.x *= -1;
		if (this.pos.y <= 0 || this.pos.y >= height) this.vel.y *= -1;
	}

	update() {
		this.pos.x += this.vel.x;
		this.pos.y += this.vel.y;
	}

	draw(context) {
		// context.save();
		// context.translate(this.pos.x, this.pos.y);

		// context.lineWidth = 4;

		// context.beginPath();
		// context.arc(0, 0, this.radius, 0, Math.PI * 2);
		// context.fill();
		// context.stroke();

		// context.restore();
	}
}

const maxDist = 500;
function drawAgents(context, width, height) {
  context.save()
  context.strokeStyle = "white";
  for (let i = 0; i < agents.length; i++) {
    const agent = agents[i];

    for (let j = i + 1; j < agents.length; j++) {
      const other = agents[j];

      const dist = agent.pos.getDistance(other.pos);

      // if (dist > maxDist) continue;
      context.strokeStyle = `rgba(255,255,255,${math.mapRange(dist, 0, maxDist, 0.05, 0)})`
      context.lineWidth = 2;


      context.beginPath();
      context.moveTo(agent.pos.x, agent.pos.y);
      context.lineTo(other.pos.x, other.pos.y);
      context.stroke();
    }
  }

  agents.forEach(agent => {
    agent.update();
    agent.draw(context);
    agent.bounce(width, height);
  });

  context.restore();
}

    canvasSketch(sketch, settings);
